/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.ECommerce {

    import fld = PickUpItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class PickUpItemsEditor extends _Ext.ItemGridEditor<PickUpItemsRow> {
        protected getColumnsKey() { return "ECommerce.PickUpItems"; }
        protected getDialogType() { return PickUpItemsDialog; }
        protected getLocalTextPrefix() { return PickUpItemsRow.localTextPrefix; }

        protected form: PickUpItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = false;
            return opt;
        }
        // #region Variables 
        public PartyId: number; 
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public POSCustomerId: number;
        public TransDate: Date;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU: boolean = false;
        public TotalItems: number;
        public isUpdate: number;
        public canUpdate: number;
        public MasterEntity: any;
        isEditable: boolean;

        // #endregion

        // #region Constructor
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true, rowHeight: 30 });
            this.toolbar.findButton('add-button').find('.button-inner').text('New Product');
             
            var value = q.ToBool(TabAurous.GetConfigValue(1004)); 
            if (value == true)
                this.GenSKU = true;
            else
                this.GenSKU = false;

            this.isEditable = this.slickGrid.getOptions().editable;


            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0 && this.isEditable==true) {
                    (this.parentDialog as PickUpDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            })
        }
        // #endregion

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
 

            return columns;
        }

        // #endregion

        // #region Common Functions

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }

        setMasterValues() {
            this.RateListId = (this.parentDialog as PickUpDialog).RateListId;
            this.LaborListId = (this.parentDialog as PickUpDialog).LaborListId;
            this.StoneMarkup = (this.parentDialog as PickUpDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as PickUpDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as PickUpDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as PickUpDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as PickUpDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as PickUpDialog).form.TransDate.valueAsDate;
            this.PartyId = (this.parentDialog as PickUpDialog).form.PartyId.value;
            this.POSCustomerId = parseInt((this.parentDialog as PickUpDialog).form.POSCustomerId.value);
        }

        public Editable() {
            this.isEditable = true;
        }
         
        public setEditValue(source: PickUpRow, property) { 
            super.setEditValue(source, property);
        }

        // **** to Call shortcut key in Main Window
        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }

        // #endregion

        //#region  ItemGrid Inline Editor

        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight || field === fld.Discount || field === fld.UnitRate) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0 && item.ItemTypeId == 101) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.NetAmount * value;
                    item.Weight = (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = (item.NetWeight / item.Pieces) * value;
                    item.BOMDetails.forEach(function (x) {
                        var Pieces = (x.Pieces / item.Pieces) * value;
                        var Weight = (x.Weight / item.Pieces) * value;
                        if (x.CalcOnId == 3) {
                            x.BomAmount = x.BomRate * Pieces;
                        }
                        else {
                            if (x.ItemTypeId == 104)
                                x.BomAmount = x.BomRate * Weight * x.Purity;
                            else
                                x.BomAmount = x.BomRate * Weight;
                        }
                        x.Pieces = Pieces;
                        x.Weight = Weight;
                    })
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                }
                item[field] = value;
                //item.LaborDetails.forEach(function (labor) {
                //    labor.Pieces = value;
                //})
            }
            // **** Allow to Set Pcs to Zero for RM ****
            if (field === fld.Pieces && item.ItemTypeId != 101) {
                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = ((item.UnitRate + labr) / item.Pieces) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }
                //item.LaborDetails.forEach(function (labor) {
                //    labor.Pieces = value;
                //})

            }

            // **** Allow to Set Weight for RM ****
            if (field === fld.Weight && !item.HasBom) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var rate = item.UnitRate || 0;
                    if (item.ItemTypeId == 101 || item.ItemTypeId == 104) {
                        rate = item.UnitRate * item.Purity;
                    }

                    var Net = (rate + labr) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.NetWeight = value;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

                //item.LaborDetails.forEach(function (labor) {
                //    labor.Weight = value;
                //})
            }

            // **** Calculate Amount based on UnitRate and Weight or Pieces
            if (field === fld.UnitRate && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var NetAmount = (item.Weight * value) + labr;
                    item.NetAmount = NetAmount;
                    var Discount = NetAmount * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = NetAmount - Discount;
                }


                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var NetAmount = (item.Pieces * value) + labr;
                    item.NetAmount = NetAmount;
                    var Discount = NetAmount * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = NetAmount - Discount;
                }
                item[field] = value;
            }

            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item.DiscountPer = (value / item.NetAmount) * 100;
                item[field] = value;
            }

            // *** Calculate Discount % ***
            if (field === fld.DiscountPer && value >= 0) {
                var Discount = (item.NetAmount * value) / 100
                item.GrossAmount = item.NetAmount - Discount;
                item.Discount = Discount;
                item[field] = value;
            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;
            }

            this.view.updateItem(id, item);

            this.view.refresh();
            (this.parentDialog as PickUpDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion
        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();

            buttons=buttons.filter(x => x.cssClass != "add-button");
            buttons.push({
                title: "Select Orders", 
                hotkey: "alt+k",
                onClick: () => {

                    var grid = Common.PickUpOrderItemsSelectGrid;
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (this.POSCustomerId == 0 || this.POSCustomerId == null) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;
                    }

                    else {
                        var custid = this.POSCustomerId;
                        var filters: _Ext.SelectGridFilters = {
                            CustomerId: this.POSCustomerId,
                            InStock: false
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true,
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });

                        var ItemDetails = ItemGridHelper.SetRetailItemGrid(selectedItems2, new Date(), this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);
                        this.setData(ItemDetails);
                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            }); 
            return buttons;
        }
        // #endregion

        // #region Set Data

        setData(ItemDetails: any[]) { 
            for (let Itemdetail of ItemDetails) {
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                var x = Itemdetail;
                this.view.addItem(Itemdetail);
            }
        }

        // #endregion


    }
}